import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { VersionId } from '../../../common/model';
import type { RelatedIssueCountResponse } from './types';

export const relatedIssueCountUrl = (baseUrl: string, id: VersionId): string =>
	`${baseUrl}/rest/api/2/version/${id}/relatedIssueCounts`;

export const getRelatedIssueCount = (
	baseUrl: string,
	versionId: VersionId,
): Promise<RelatedIssueCountResponse> => fetchJson(relatedIssueCountUrl(baseUrl, versionId));
